import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('GA Measurement ID 未配置');
    return;
  }
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = ({ category, action, label, value }) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event({ category, action, label, value });
};
